import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable()
export class MadLibStoreStateResolver {
  resolveMadLibStoreState$(madLibSelector, store): Promise<Observable<any>> {
    return new Promise(resolve => {
      store
        .select(madLibSelector)
        .pipe(take(1))
        .subscribe(madlibState => resolve(madlibState));
    });
  }
}
